import { type Registry as Services, service } from '@ember/service';
import { modifier } from 'ember-modifier';
import { cached } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const CALENDLY_LINK =
  'https://calendly.com/d/cnbp-vs7-m6p/uplisting-trial-15-minute-discovery-call-t1';

export default class RegisterMeetingController extends BaseController {
  @service sentry!: Services['sentry'];

  @cached
  get prefillData(): string {
    const { currentUser } = this;

    const params: string[] = [];

    if (currentUser.name) {
      params.push(`name=${currentUser.name.replaceAll(' ', '%20')}`);
    }

    if (currentUser.email) {
      params.push(`email=${currentUser.email}`);
    }

    return params.join('&');
  }

  @cached
  get utmData(): string {
    // Get cookies as an object
    const cookieMap = Object.fromEntries(
      document.cookie.split('; ').map((c) => c.split('=')),
    );

    let utmData = {};

    if (cookieMap.utmParams) {
      try {
        utmData = JSON.parse(decodeURIComponent(cookieMap.utmParams));
      } catch (error) {
        this.sentry.captureException(error);
      }
    }

    const utmQuery = UTM_KEYS.filter((key) => utmData[key])
      .map((key) => `${key}=${encodeURIComponent(utmData[key])}`)
      .join('&');

    const base = 'embed_domain=app.uplisting.io&embed_type=Inline';

    if (utmQuery) {
      return `${utmQuery}&${base}`;
    }

    return base;
  }

  @cached
  get dataUrl(): string {
    if (this.prefillData) {
      return `${CALENDLY_LINK}?${this.prefillData}&${this.utmData}`;
    }

    return `${CALENDLY_LINK}?${this.utmData}`;
  }

  handleInsert = modifier((element: HTMLDivElement) => {
    const script = document.createElement('script');

    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;

    element?.insertAdjacentElement('afterend', script);
  });
}
